import { socialMedian } from "../models/models";

export const social: socialMedian[] = [
    {
        platform: 'LinkedIn',
        hreflinks:'https://www.linkedin.com/in/zahid-shaik',
    },
    {
        platform: 'GitHub',
        hreflinks:'https://github.com/ZaahidShaik',
    },
    {
        platform: 'Gmail',
        hreflinks:'mailto:zahidshaik01@gmail.com',
    },
]